import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "#app/components/auth/auth-layout";
import { LoginForm } from "#app/components/auth/login-form";

function LoginScreen() {
  return (
    <AuthLayout
      heading="Log in to SalesTrak"
      legalAction="logging in"
      footerText="Don't have an account?"
      footerLinkText="Sign up"
      footerLinkHref="/register"
    >
      <LoginForm />
    </AuthLayout>
  );
}

export const Route = createFileRoute("/(auth)/login")({
  // The page a signed-out visit asked for; log in goes back to it.
  validateSearch: (search: Record<string, unknown>): { redirect?: string } =>
    typeof search.redirect === "string" ? { redirect: search.redirect } : {},
  component: LoginScreen,
});
